/* eslint-disable import/no-named-as-default */
import * as Sentry from '@sentry/browser';
import {
  defaultDataIdFromObject,
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { createHttpLink } from 'apollo-link-http';

import introspectionQueryResultData from './graphql/fragmentTypes.json';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

const cache = new InMemoryCache({
  cacheRedirects: {
    Query: {
      company: (_, args, { getCacheKey }) => {
        const cacheObject = { __typename: 'Company', id: args.id };
        return getCacheKey(cacheObject);
      },
      audience: (_, args, { getCacheKey }) => {
        const cacheObject = { __typename: 'Audience', id: args.id };
        return getCacheKey(cacheObject);
      },
    },
  },
  dataIdFromObject: (object) => {
    switch (object.__typename) {
      case 'Attribute': {
        // attributeType is added by the backend to ensure
        // person attributes and company attributes don't overwrite each other!
        const { category, value, subCategory, attributeType } = object;
        return `${object.__typename}:${attributeType}:${category}-${subCategory}-${value}`;
      }
      default:
        return defaultDataIdFromObject(object);
    }
  },
  fragmentMatcher,
});

const client = new ApolloClient({
  cache,
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach((error) => {
          const { message, locations, path } = error;
          /* eslint-disable-next-line no-console */
          console.error(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
          );

          Sentry.captureException(error);
        });
      }
      /* eslint-disable-next-line no-console */
      if (networkError) console.error(`[Network error]: ${networkError}`);
    }),
    createHttpLink({
      uri: (query) => {
        return `/graphql?${query.operationName}`;
      },
    }),
  ]),
});

export default client;
